type LocalePath = ReturnType<typeof useLocalePath>

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.localePath = (...args: Parameters<LocalePath>) => (nuxtApp.$localePath as LocalePath)(...args)
})
